import { useEffect, useState } from "react";
import auth from "../../../services/auth";
import DasboardService from "../../../services/DashboardService";
import CustomBarChart from "./BarChart.jsx";
import { getGroupAccountTypesByEducationLevel } from "../../../utils/utils";
import { Collapse, IconButton, Tooltip as TP } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { ACCOUNT_TYPE } from "../../../utils/constants";
import DataPieChart from "../../../components/PieChart";

const ClientAdminDashboard = (props) => {
  const [data, setData] = useState([]);
  const [isDataForChart, setIsDataForChart] = useState(false);
  const [expanded, setExpanded] = useState(true);

  const authenticatedUserDetail = auth.getUserDetails();

  const loadData = async () => {
    const cohortProgress =
      await DasboardService().getCohortParticipantProgressStatusPercentageByAccount(
        authenticatedUserDetail?.accId
      );
    setIsDataForChart(cohortProgress?.data.every((item) => item.value === 0));
    setData(cohortProgress?.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      {/* Full-width header */}
      <div className="card w-100">
        <div className="card-header d-flex justify-content-between align-items-center w-100 btn-styling">
          <div className="flex-grow-1">
            <label className="sub-heading">
              <b>{`${getGroupAccountTypesByEducationLevel(
                props.accountType
              )} Learning and Development Charts`}</b>
            </label>
          </div>
          <TP title={expanded ? "Collapse" : "Expand"}>
            <IconButton
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
              aria-label="show more"
            >
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </TP>
        </div>
      </div>

      {/* Expandable Content */}
      <Collapse in={expanded} style={{ width: "100%" }}>
        {props.accountType !== ACCOUNT_TYPE.HIGHER_ED && (
          <div className="d-flex flex-wrap w-100">
            {/* Pie Chart Section */}
            <div className="col-12 col-md-12 d-flex flex-column align-items- p-3">
              <>
                <h3 className="sub-heading text-center">
                  {`${getGroupAccountTypesByEducationLevel(
                    props.accountType
                  )} Leadership Pipeline Progress`}
                </h3>
                <DataPieChart
                  data={data}
                  isDataForChart={isDataForChart}
                  legendWidth={true}
                />
              </>
            </div>
          </div>
        )}

        <CustomBarChart accountType={props.accountType} />
      </Collapse>
    </>
  );
};

export default ClientAdminDashboard;
